import styled, { css } from 'styled-components/macro'

export const AnimationContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  @media (max-width: 1024px) {
    aspect-ratio: 256/267;
  }
  @media (max-width: 742px) {
    aspect-ratio: 256/290;
  }
  @media (max-width: 520px) {
    aspect-ratio: 115/157;
  }

  @media (max-width: 1024px) {
    position: absolute;
    min-height: 100%;
    min-width: 100%;
    width: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    left: auto;
    right: 0;
    transform: translateY(-50%);
  }
  @media (max-width: 742px) {
    right: auto;
    left: 75%;
    transform: translate(-75%, -50%);
  }
  @media (max-width: 520px) {
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
  }
`
export const Background = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  object-fit: cover;
  object-position: center top;
`
export const HandMobile = styled.img<{ $isPageVisible: boolean }>`
  position: absolute;
  bottom: -60%;
  left: 51%;
  //width: 43%;
  height: 90%;
  transform: rotate(-30deg) translateX(-20%);
  transform-origin: bottom right;
  transition: all 1s;
  transition-timing-function: cubic-out;
  @media (max-width: 1024px) {
    left: auto;
    right: 0;
    width: 49%;
    height: auto;
    transform: rotate(-30deg);
  }
  @media (max-width: 520px) {
    width: 73%;
    right: -10%;
  }
  ${(props) =>
    props.$isPageVisible
      ? css`
          bottom: 0%;
          transform: rotate(0deg) translateX(-20%);
          @media (max-width: 1024px) {
            transform: rotate(0deg);
          }
          @media (max-width: 520px) {
            bottom: 6%;
          }
        `
      : ''}
`
export const WomanShadow = styled.img<{ $isPageVisible: boolean }>`
  position: absolute;
  //width: 48.5%;
  height: 65.5%;
  //left: 16.4%;
  right: 50%;
  bottom: 0;
  opacity: 0;
  transform: translateX(30%);
  transition: all 1.5s;
  transition-delay: 1s;
  transition-timing-function: ease-in;
  @media (max-width: 1024px) {
    left: 3%;
    right: auto;
    width: 89%;
    height: auto;
    transform: translateX(0);
  }
  @media (max-width: 520px) {
    left: -5%;
    width: 64%;
    bottom: -9%;
  }
  ${(props) => (props.$isPageVisible ? 'opacity: 1;' : '')}
`
